/* import __COLOCATED_TEMPLATE__ from './emoji-group-sections.hbs'; */
import Component from "@ember/component";

export default class EmojiGroupSections extends Component {}
